import { render, staticRenderFns } from "./Pay.vue?vue&type=template&id=4b69590e&scoped=true"
import script from "./Pay.vue?vue&type=script&lang=ts"
export * from "./Pay.vue?vue&type=script&lang=ts"
import style0 from "./Pay.vue?vue&type=style&index=0&id=4b69590e&prod&lang=scss"
import style1 from "./Pay.vue?vue&type=style&index=1&id=4b69590e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b69590e",
  null
  
)

export default component.exports